import { render } from "./TheError.vue?vue&type=template&id=986e5a8a&ts=true"
import script from "./TheError.vue?vue&type=script&lang=ts"
export * from "./TheError.vue?vue&type=script&lang=ts"

import "./TheError.vue?vue&type=style&index=0&id=986e5a8a&lang=css"

import exportComponent from "F:\\hotaru_theme_for_RustVersion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__